/*
 * @Author: 大明冯
 * @Date: 2018-08-07 10:50:17
 * @Last Modified by: 大明冯
 * @Last Modified time: 2018-08-07 11:40:39
 */

import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import plugins from './plugins'
import getters from './getters'
import crumb from './modules/crumb'
import works from './modules/works'
import user from './modules/user'
import subject from './modules/subject'
import toast from './modules/toast'
import catalog from './modules/catalog'
import navstate from './modules/nav_state'


Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    crumb,
    works,
    user,
    subject,
    toast,
    catalog,
    navstate,
  },
  plugins
})



// WEBPACK FOOTER //
// ./src/store/index.js